import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import Scrollbar from '../../control/Scrollbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem, { listItemClasses } from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import AppIcon from '@mui/icons-material/AppsOutlined'
import CloseIcon from '@mui/icons-material/CancelOutlined'
import { RootStateType } from '../../redux/reducer/rootReducer'
import { ReactComponent as MapIcon } from '../../icon/map_menu_map.svg'
import { ReactComponent as TvIcon } from '../../icon/map_menu_tv.svg'
import { ReactComponent as GuidanceIcon } from '../../icon/map_menu_tv_info.svg'
import { ReactComponent as NetworkIcon } from '../../icon/map_menu_network.svg'
import { ReactComponent as ContactIcon } from '../../icon/map_menu_contact.svg'
import { ReactComponent as HelpIcon } from '../../icon/map_menu_help.svg'
import { ReactComponent as SuggestIcon } from '../../icon/map_menu_suggest.svg'
import { ReactComponent as ReportIcon } from '../../icon/map_menu_report.svg'
import { ReactComponent as BackofficeIcon } from '../../icon/map_menu_backoffice.svg'
import { ReactComponent as ProfileIcon } from '../../icon/map_menu_profile.svg'
import { ReactComponent as LoginIcon } from '../../icon/map_menu_login.svg'

const LogoWhiteImage = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/logo_system_name.png`
const LogoColorImage = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/logo_color.png`

type MenuProps = {
    onClickMenuItem?: (item: MapMenuType) => void
    onCloseDrawer?: () => void
    onClickLogo?: () => void
    menuList: MapMenuType[]
}

const CoreMenu = (props: MenuProps) => {
    const { isLoggedIn, loginProfile } = useSelector(({ profile }: RootStateType) => profile)
    const { onCloseDrawer, onClickMenuItem, onClickLogo, menuList } = props
    const classes = useStyles({ onClickLogo })

    const getMenuIcon = (id: string | number) => {
        const width = 20
        const height = 20
        switch (id) {
            case 99: // Profile
                return isLoggedIn ? (
                    <ProfileIcon width={width} height={height} />
                ) : (
                    <LoginIcon width={width} height={height} />
                )
            case 1: // เพิ่มแผนที่จากหน่วยงานอื่น
                return <MapIcon width={width} height={height} />
            case 2: // ข้อมูลช่องรายการ
                return <TvIcon width={width} height={height} />
            case 3: // วิธีการติดตั้ง และรับชม
                return <GuidanceIcon width={width} height={height} />
            case 4: // แผนการขยายโครงข่ายฯ
                return <NetworkIcon width={width} height={height} />
            case 5: // รายงานข้อเสนอแนะ
                return <SuggestIcon width={width} height={height} />
            case 6: // รายงานผลการนำเข้า
                return <ReportIcon width={width} height={height} />
            case 7: // ระบบการจัดการ
                return <BackofficeIcon width={width} height={height} />
            case 8: // ช่วยเหลือ
                return <HelpIcon width={width} height={height} />
            case 9: // ติดต่อเรา
                return <ContactIcon width={width} height={height} />
            default:
                return <AppIcon width={width} height={height} />
        }
    }

    const getPath = (id: string | number, path: string) => {
        switch (id) {
            case 99:
            case '99':
                return isLoggedIn ? '/profile' : '/login'
            default:
                return path
        }
    }

    const buildMenuMap = (isLogIn: boolean) => {
        let result: MapMenuType[] = menuList

        if (!isLogIn) {
            const profileMenu = menuList.find((m) => m.id === 99)
            const otherMenus = menuList.filter((m) => m.id !== 99)

            result = profileMenu ? [...otherMenus, profileMenu] : otherMenus
        }

        return result
    }

    return (
        <Container>
            <StyledDivMenu>
                <StyledDivMenuHeader>
                    <div>
                        <StyledImgLogoMenuHeader
                            src={LogoWhiteImage}
                            onClick={() => {
                                onClickLogo?.()
                            }}
                            className={classes.logoMenuHeader}
                        />
                    </div>
                    <div>
                        <IconButton aria-label="close" onClick={onCloseDrawer} sx={{ color: '#fff' }}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </StyledDivMenuHeader>
                {/* <div style={{ width: '100%', height: 'calc(100% - 200px)' }}> */}
                <div style={{ width: '100%' }}>
                    <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                        <List className={classes.list}>
                            {buildMenuMap(isLoggedIn)?.map(
                                (item: MapMenuType, index: number) =>
                                    item.display &&
                                    (item.id === 7 ? !isMobile : true) && (
                                        <StyledLink to={getPath(item.id, item.path)} key={index}>
                                            <ListItem
                                                button
                                                key={index}
                                                onClick={() => {
                                                    onClickMenuItem?.(item)
                                                }}
                                                classes={{
                                                    root: item.id === 99 ? classes.listItemLogin : classes.listItem,
                                                    selected: classes.selected,
                                                }}
                                            >
                                                <ListItemIcon classes={{ root: classes.listItemIconLeft }}>
                                                    {getMenuIcon(item.id)}
                                                </ListItemIcon>
                                                <div>
                                                    <ListItemText
                                                        primary={
                                                            item.id === 99
                                                                ? isLoggedIn
                                                                    ? loginProfile?.fullname
                                                                    : 'สำหรับเจ้าหน้าที่'
                                                                : item.name
                                                        }
                                                        primaryTypographyProps={
                                                            item.id === 99
                                                                ? {
                                                                      noWrap: true,
                                                                      style: {
                                                                          width: '210px',
                                                                      },
                                                                  }
                                                                : undefined
                                                        }
                                                    />
                                                    {item.id === 99 && (
                                                        <div style={{ display: 'flex', width: '210px' }}>
                                                            <StyledTypoProfileEmail noWrap>
                                                                {loginProfile?.email}
                                                            </StyledTypoProfileEmail>
                                                        </div>
                                                    )}
                                                </div>
                                            </ListItem>
                                        </StyledLink>
                                    ),
                            )}
                        </List>
                    </Scrollbar>
                </div>
                {/* <StyledImgLogoMenuFooter src={LogoColorImage} /> */}
            </StyledDivMenu>
        </Container>
    )
}

export default CoreMenu

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    list: {
        color: theme.palette.text.secondary,
        '& svg': {
            width: '20px',
            fill: theme.palette.text.secondary,
        },
        [`& .active, & .${listItemClasses.root}:hover`]: {
            color: theme.palette.primary.main,
            '& svg': {
                width: '20px',
                fill: theme.palette.primary.main,
            },
        },
    },
    listItem: {
        margin: '4px 0px 4px 10px !important',
        maxWidth: '280px !important',
        borderRadius: '5px 0 0 5px !important',
        '&:hover': { background: '#ffffff !important' },
        '&$selected': {
            background: '#ffffff !important',
            '&:hover': {
                background: '#ffffff !important',
            },
        },
    },
    listItemLogin: {
        margin: '4px 5px !important',
        maxWidth: '280px !important',
        borderRadius: '5px !important',
        background: '#10267680 !important',
        '&:hover': {
            background: '#ffffff !important',
        },
        '&$selected': {
            background: '#ffffff !important',
            '&:hover': {
                background: '#ffffff !important',
            },
        },
    },
    selected: {},
    listItemIconLeft: {
        minWidth: '40px !important',
    },
    listItemIconRight: {
        minWidth: '20px !important',
    },
    iconMenu: {
        fill: `${theme.palette.text.secondary} !important`,
    },
    iconMenuRight: {
        fontSize: '15px !important',
    },
    menuName: {
        color: `${theme.palette.text.secondary} !important`,
    },
    logoMenuHeader: {
        height: 45,
        imageRendering: '-webkit-optimize-contrast',
        cursor: (props: any) => (props.onClickLogo ? 'pointer' : ''),
    },
}))

const Container = styled('div')(({ theme }) => ({
    width: '100%',
    height: '100%',
}))

const StyledLink = styled(Link)(({ theme }) => ({
    color: 'inherit',
    textDecoration: 'none',
}))

const StyledDivMenuHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 10px 10px 20px',
    background: theme.palette.secondary.dark,
    boxShadow: theme.palette.getContrastText('shadow-bottom'),
}))

const StyledDivMenu = styled('div')(({ theme }) => ({
    width: '290px',
    height: '100%',
}))

const StyledImgLogoMenuHeader = styled('img')(({ theme }) => ({
    height: '45px',
}))

const StyledImgLogoMenuFooter = styled('img')(({ theme }) => ({
    height: 120,
    position: 'fixed',
    bottom: 0,
}))

const StyledTypoProfileEmail = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.disabled,
    fontSize: '14px',
}))
